import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { Link, useNavigate } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import moment from "moment";
import Header from "../../layout/Header";
import { getDate, selectValueGetter } from "../../../../utils/helper";
import TextValidator from "../../partial/TextValidator";
import { decrypt } from "../../../../utils/encodingdecoding";

import SelectValidator from "../../partial/SelectValidator";
import { generateQRCode, generateQRTemplate } from "../../../../components/pages/campaigns/services";
import { getPromotion } from "../../../../actions/auth";
import { backIcon2 } from "../../../../Image/Index";
import { connect } from "react-redux";
import { clearSetting, getProfile } from "../../../../actions/setting";

const QRCode = ({ getProfile, clearSetting, Setting }) => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState([]);
    const [subCategoryOption, setSubCategoryOption] = useState([]);
    const [productIdOption, setProductIdOption] = useState([]);
    const [allData, setAllData] = useState([]);
    const [valueTypeOption] = useState([
        { value: "NoValue", label: "No Value" },
        { value: "PreLoadedValue", label: "Pre Loaded Value" },
    ]);
    const [typeOption] = useState([
        { value: "Distributor", label: "Distributor" },
        { value: "Retailer", label: "Retailer" },

    ]);
    const [qrTypeOption] = useState([
        { value: "Item", label: "Item" },
        { value: "Box", label: "Box" },
    ])
    const [loader, setLoader] = useState(false);

    const initialState = {
        valuetype: "",
        value: "",
        quantity: "",
        status: false,
        productId: "",
        productName: null,
        category: null,
        subCategory: null,
        type: "",
        QRCodetype: "",
        redemptionlimittype: false,
        redemptionlimitcount: "",
        issuedate: "",
        expirydate: "",
        readOnly: false
    };
    const [state, setState] = useState(initialState);
    const [dateErr, setDateErr] = useState(false);

    useEffect(() => {
        ValidatorForm.addValidationRule("maxQuantity200", (value) => {
            if (!value) return true;
            return Number(value) <= 200;
        });

        return () => {
            ValidatorForm.removeValidationRule("maxQuantity200");
        };
    }, []);

    useEffect(() => {
        let tempEndDate = moment(state.expirydate).diff(moment(state.issuedate), "days");
        if (tempEndDate < 0) {
            setDateErr(true);
        } else {
            setDateErr(false);
        }
    }, [state.issuedate, state.expirydate]);

    const fetchOffer = async () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const Id = decrypt(localStorage.getItem("Id"));
        try {
            const res = await getPromotion(token?.access_token, Id);
            setAllData(res?.data);
            const categories = res?.data.map((item) => item.category);
            const uniqueCategories = [...new Set(categories)];
            const categoryOptions = [
                { value: "", label: "Select" },
                ...uniqueCategories.map((cat) => ({
                    value: cat,
                    label: cat,
                })),
            ];
            setResponseData(categoryOptions);
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };
    useEffect(() => {
        if (state.category) {
            const filteredSubCategories = allData
                .filter((item) => item.category === state.category)
                .map((item) => ({
                    value: item['subCategory'],
                    label: item['subCategory'],
                }));
            const uniqueSubCategories = [
                { value: "", label: "Select" },
                ...new Map(filteredSubCategories.map((item) => [item.value, item])).values(),
            ];
            setSubCategoryOption(uniqueSubCategories);
        } else {
            setSubCategoryOption([]);
        }
    }, [state.category, allData]);

    useEffect(() => {
        if (state.category) {
            const filteredSubCategories = allData
                .filter((item) => item['subCategory'] === state.subCategory)
                .map((item) => ({
                    value: item['product_Name'],
                    label: item['product_Name'],
                    points: item["points"],
                    productId: item["productID"]
                }));
            const uniqueSubCategories = [
                { value: "", label: "Select" },
                ...new Map(filteredSubCategories.map((item) => [item.value, item])).values(),
            ];
            setProductIdOption(uniqueSubCategories);
        } else {
            setProductIdOption([]);
        }
    }, [state.subCategory, allData]);
    useEffect(() => {
        fetchOffer();
    }, []);

    const handleKeyDown = (e) => {
        const allowedKeys = [
            "Backspace",
            "ArrowLeft",
            "ArrowRight",
            "Delete",
            "Tab",
            "Ctrl",
        ];

        if (e.ctrlKey && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) {
            return;
        }

        if (e.key === " ") {
            e.preventDefault();
            return;
        }

        if (allowedKeys.includes(e.key)) {
            return;
        }

        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    };
    const onSelectChange = (e, name) => {
        const temp = e?.value === "" ? null : e?.value;
        setState((prevState) => ({
            ...prevState,
            [name]: temp,
            ...(name === "category" && { subCategory: "" }),
            ...(name === "subCategory" && { productName: "" }),
        }));
        if (name === "productName") {
            const details = productIdOption.find((ele) => ele.value === temp);
            setState((prev) => ({
                ...prev,
                value: details ? details.points : "",
                productId: details?.productId,
                readOnly: !!details
            }));
        }
    };


    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const handleStatus = () => {
        setState((prevState) => ({
            ...prevState,
            status: !prevState.status,
        }));
    };

    const handleRedemptionLimit = () => {
        setState((prevState) => ({
            ...prevState,
            redemptionlimittype: !prevState.redemptionlimittype,
        }));
    };

    const handleDateTime = (e) => {
        setState((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const handleReset = async () => {
        setState(initialState);
    };
    const onSubmit = async () => {
        if (!dateErr) {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem("token_gen"));
            const { value, redemptionlimitcount, readOnly, productName, ...rest } = state;
            const updatedName = `${productName}#${moment().format("DD-MM-YYYY HH:mm:ss")}`;
            const body = {
                ...rest,
                status: state.status ? "Active" : "InActive",
                redemptionlimittype: state.redemptionlimittype ? "Multiple" : "OneTime",
                quantity: Number(state.quantity),
                productName: updatedName,
                ...(state.valuetype === "PreLoadedValue" && {
                    value: Number(state.value),
                }),
                ...(state.redemptionlimittype && {
                    redemptionlimitcount: Number(state.redemptionlimitcount),
                }),
            };
            const res = await generateQRTemplate(token?.access_token, body);
            if (res.message === "Record Created Successfully.") {
                await clearSetting();
                let body = {
                    email: localStorage.getItem("email"),
                    merchcode: localStorage.getItem("merchantcode"),
                };
                const profileRes = await getProfile(token?.access_token, body);
                await generateQRCode(token.access_token, {
                    templatecode: res?.data?.templatecode,
                    url: `${profileRes?.rewardportal}.paybypoint.com/qr-code-details`
                });
                swal({
                    position: "center",
                    icon: "success",
                    title: "QR code template create successfully",
                    showConfirmButton: false,
                    timer: 5000,
                });
            } else {
                swal({
                    title: " Oops!",
                    text: res.message,
                    icon: "error",
                    button: "oh no!",
                    timer: 5000,
                });
            }
            setState(initialState);
            navigate("/channel-partner/qrcode-template");
            setLoader(false);
        }
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"QR Code Template"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__profileSettingsMain">
                        <div className="dashboard__heading">
                            <div className="dashboard__headingLeft">
                                <div className="dashboard__headingBackLink">
                                    <Link to="" onClick={() => navigate(-1)} >
                                        <img src={backIcon2} alt="" />
                                        <div className="dashboard__headingContent">
                                            <h3>QR Code Template</h3>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard__profileSettingsBox">
                            <ValidatorForm className="customForm customForm_2" onSubmit={onSubmit}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Product Category
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select"
                                                className="custom-ReactSelect bordered"
                                                name="category"
                                                onChange={(e) => onSelectChange(e, "category")}
                                                options={responseData}
                                                validators={["required"]}
                                                errorMessages={["Please select  category"]}
                                                value={selectValueGetter(responseData, state.category) || null}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Product Sub Category

                                            </label>
                                            <SelectValidator
                                                placeholder="Select"
                                                className="custom-ReactSelect bordered"
                                                name="subCategory"
                                                onChange={(e) => onSelectChange(e, "subCategory")}
                                                options={subCategoryOption}

                                                value={
                                                    selectValueGetter(subCategoryOption, state.subCategory) || null
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Product Name {state.productName ? `(${state.productId})` : ""}

                                            </label>
                                            <SelectValidator
                                                placeholder="Select"
                                                className="custom-ReactSelect bordered"
                                                name="productName"
                                                onChange={(e) => onSelectChange(e, "productName")}
                                                options={productIdOption}

                                                value={
                                                    selectValueGetter(productIdOption, state.productName) || null
                                                }
                                            />
                                        </div>
                                    </div>


                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Quantity
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <TextValidator
                                                maxLength="50"
                                                className="form-control"
                                                name="quantity"
                                                value={state.quantity}
                                                onChange={(e) => onChange(e)}
                                                validators={["required", "maxQuantity200"]}
                                                errorMessages={[
                                                    "Please enter quantity",
                                                    "Quantity cannot be greater than 200",
                                                ]}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div className="form-group">
                                                <label>
                                                    Redemption Limit Type
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <label className="toggle">
                                                    <input
                                                        type="checkbox"
                                                        name="redemptionlimittype"
                                                        checked={state.redemptionlimittype}
                                                        onChange={handleRedemptionLimit}
                                                    />
                                                    <span className="slider"></span>
                                                    <span className="labels" data-on="Multiple" data-off="OneTime"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {state.redemptionlimittype && (
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>
                                                    Redemption Limit Count
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <TextValidator
                                                    maxLength="50"
                                                    className="form-control"
                                                    name="redemptionlimitcount"
                                                    value={state.redemptionlimitcount}
                                                    onChange={(e) => onChange(e)}
                                                    validators={["required"]}
                                                    errorMessages={["Please enter redemption limit count"]}
                                                    onKeyDown={handleKeyDown}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                QR Type
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select Type"
                                                className="custom-ReactSelect bordered"
                                                name="type"
                                                value={selectValueGetter(typeOption, state.type) || ""}
                                                options={typeOption}
                                                validators={["required"]}
                                                errorMessages={["Please select type"]}
                                                onChange={(e) => onSelectChange(e, "type")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                QRCode Type
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select Type"
                                                className="custom-ReactSelect bordered"
                                                name="QRCodetype"
                                                value={selectValueGetter(qrTypeOption, state.QRCodetype) || ""}
                                                options={qrTypeOption}
                                                validators={["required"]}
                                                errorMessages={["Please select QRCode type"]}
                                                onChange={(e) => onSelectChange(e, "QRCodetype")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Activation Date
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <TextValidator
                                                className="form-control"
                                                name="issuedate"
                                                type="date"
                                                value={
                                                    state.issuedate
                                                        ? getDate(state.issuedate, "YYYY-MM-DD")
                                                        : ""
                                                }
                                                min={getDate(new Date(), "YYYY-MM-DD")}
                                                onChange={handleDateTime}
                                                validators={["required"]}
                                                errorMessages={["Please enter activation date"]}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div className="form-group">
                                                <label>
                                                    Value Type
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <SelectValidator
                                                    placeholder="Select Type"
                                                    className="custom-ReactSelect bordered"
                                                    name="valuetype"
                                                    value={selectValueGetter(valueTypeOption, state.valuetype) || ""}
                                                    options={valueTypeOption}
                                                    validators={["required"]}
                                                    errorMessages={["Please select type"]}
                                                    onChange={(e) => onSelectChange(e, "valuetype")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {state.valuetype === "PreLoadedValue" && (
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>
                                                    Value
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <TextValidator
                                                    maxLength="50"
                                                    className="form-control"
                                                    name="value"
                                                    readOnly={state.readOnly}
                                                    value={state.value}
                                                    onChange={(e) => onChange(e)}
                                                    validators={["required"]}
                                                    errorMessages={["Please enter value"]}
                                                    onKeyDown={handleKeyDown}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Expiration Date
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <TextValidator
                                                className="form-control"
                                                name="expirydate"
                                                type="date"
                                                value={
                                                    state.expirydate
                                                        ? getDate(state.expirydate, "YYYY-MM-DD")
                                                        : ""
                                                }
                                                onChange={handleDateTime}
                                                validators={["required"]}
                                                errorMessages={["Please enter expiration date"]}
                                            />
                                            {dateErr && (
                                                <span style={{ color: "red" }}>
                                                    Expiration date should be greater than activation date
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <div className="">
                                                    <label className="toggle">
                                                        <input
                                                            type="checkbox"
                                                            name="status"
                                                            checked={state.status}
                                                            onChange={handleStatus}
                                                        />
                                                        <span className="slider"></span>
                                                        <span className="labels" data-on="Active" data-off="Inactive"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div className="button-section">
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={handleReset}
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ValidatorForm>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

const mapStateToProps = (state) => ({
    Setting: state.Setting,
});

const mapDispatchToProps = {
    getProfile,
    clearSetting,
};
export default connect(mapStateToProps, mapDispatchToProps)(QRCode);
